<div class="card mb-3">
    <div class="card-header">
        <h5>Company Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Company Name:</strong> {{seller.companyName}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Legal Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>RCCM:</strong> {{seller.legalInfo.rccm || 'N/A'}}</p>
                <p><strong>NIU:</strong> {{seller.legalInfo.niu || 'N/A'}}</p>
                <p><strong>Business License Number:</strong> {{seller.legalInfo.businessLicenseNumber || 'N/A'}}</p>
                <p><strong>Verification Status:</strong>
                    <span class="badge" [ngClass]="seller.legalInfo.verificationStatus === 'PENDING' ? 'bg-warning' : 'bg-success'">
                        {{seller.legalInfo.verificationStatus}}
                    </span>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Legal Representative</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Full Name:</strong> {{seller.legalRepresentative.fullName}}</p>
                <p><strong>Position:</strong> {{seller.legalRepresentative.position || 'N/A'}}</p>
                <p><strong>Phone:</strong> {{seller.legalRepresentative.phoneNumber || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Documents</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <ng-container *ngIf="seller.documents && seller.documents.length > 0">
                    <div *ngFor="let doc of seller.documents" class="mb-3">
                        <p><strong>{{getDocumentTypeLabel(doc.documentType)}}:</strong></p>
                        <button class="btn btn-primary" (click)="downloadDocument(doc.id, doc.documentPath)">
                            Download Document
                        </button>
                    </div>
                </ng-container>
                <div *ngIf="!seller.documents || seller.documents.length === 0">
                    <p class="text-muted mb-0">No documents uploaded</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Operational Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Company Email:</strong> {{seller.operationalInfo.companyEmail || 'N/A'}}</p>
                <p><strong>Company Phone:</strong> {{seller.operationalInfo.companyPhoneNumber || 'N/A'}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Country:</strong> {{seller.operationalInfo.country || 'N/A'}}</p>
                <p><strong>City:</strong> {{seller.operationalInfo.city || 'N/A'}}</p>
                <p><strong>Address:</strong> {{seller.operationalInfo.address || 'N/A'}}</p>
            </div>
        </div>
        <div class="row mt-3" *ngIf="seller.operationalInfo.description">
            <div class="col-12">
                <p><strong>Description:</strong></p>
                <p>{{seller.operationalInfo.description}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3" *ngIf="seller.paymentInfo">
    <div class="card-header">
        <h5>Payment Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Payment Type:</strong>
                    {{seller.paymentInfo.paymentType === 'MOBILE_MONEY' ? 'Mobile Money' : 'Bank Transfer'}}
                </p>
            </div>
        </div>

        <!-- Mobile Money Details -->
        <div *ngIf="seller.paymentInfo.paymentType === 'MOBILE_MONEY'">
            <div class="row">
                <div class="col-md-6">
                    <p><strong>Provider:</strong> {{seller.paymentInfo.mobileMoneyProvider || 'N/A'}}</p>
                    <p><strong>Mobile Number:</strong> {{seller.paymentInfo.mobileMoneyNumber || 'N/A'}}</p>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <p><strong>Verification Status:</strong>
                        <span class="badge" [ngClass]="seller.paymentInfo.numberVerified ? 'bg-success' : 'bg-warning'">
                            {{seller.paymentInfo.numberVerified ? 'Verified' : 'Not Verified'}}
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <!-- Bank Details -->
        <div class="row" *ngIf="seller.paymentInfo.paymentType === 'BANK'">
            <div class="col-md-6">
                <p><strong>Bank Name:</strong> {{seller.paymentInfo.bankName || 'N/A'}}</p>
                <p><strong>Account Number:</strong> {{seller.paymentInfo.accountNumber || 'N/A'}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Account Holder:</strong> {{seller.paymentInfo.accountHolderName || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>
